import React from "react";
import { ArrowForwardIcon } from "components/icons/ArrowForwardIcon";
import { SwapIcon } from "components/icons/SwapIcon";
import { ButtonV2 } from "../ButtonV2/ButtonV2";

export interface RecentSearchCardV2Props {
  origin: {
    stationCode: string;
  };
  destination: {
    stationCode: string;
  };
  type: string;
  handleOnClick: () => void;
}

export function RecentSearchCardV2({ origin, destination, type, handleOnClick }: RecentSearchCardV2Props) {
  return (
    <ButtonV2
      blok={{ variant: "tertiary" }}
      onClick={handleOnClick}
      className="bg-background-default text-typography-primary rounded-md rounded-tr-none flex text-xs font-medium items-center justify-center py-2 px-4 shadow-md hover:brightness-90 gap-2"
      type="button"
      aria-label={`Recent Search from ${origin?.stationCode} to ${destination?.stationCode}`}
    >
      <span>{origin?.stationCode}</span>
      {type === "ONE_WAY" ? (
        <ArrowForwardIcon fill="currentColor" width={14} height={14} />
      ) : (
        <SwapIcon fill="inherit" width={16} height={16} />
      )}
      <span>{destination?.stationCode}</span>
    </ButtonV2>
  );
}
